import React, { useMemo } from "react";
import cx from "classnames";

import { Optional } from "common/utils/types";
import { hexToRgb } from "common/utils/colors";

import { useBreakpoints } from "client/common/hooks";
import Header from "client/common/components/header/Header";
import { useClinic } from "client/clinics/hooks";

import HomeContent from "../HomeContent";
import goodVetThemeImage from "../../images/GoodVets-Theme.png";
import goodVetThemeImageMobile from "../../images/GoodVetsTheme-Mobile.png";

import styles from "../../styles/HomeThemeGoodVets.module.less";

const primaryColor = "#FFFFFF";
const accentColor = "#D6E9DD";

const BlobOne = () => (
  <svg
    className={cx(styles.blob, styles.blobOne)}
    width="607"
    height="234"
    viewBox="0 0 607 234"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5743_50079)">
      <g opacity="0.08" filter="url(#filter0_d_5743_50079)">
        <path
          d="M396.83 -389.628C369.491 -578.675 253.902 -567.444 199.049 -537.839C113.401 -481.72 88.9828 -324.059 81.661 -262.338C75.8035 -212.96 33.3403 -94.9986 12.8409 -42.19C-21.9066 150.256 124.963 159.619 150.965 162.759C176.966 165.9 262.731 144.566 341.368 189.875C404.278 226.121 465.389 233.355 488.081 232.441C586.501 212.566 588.011 137.951 588.304 105.538C588.596 73.1261 570.715 7.21288 480.991 -83.5126C409.211 -156.093 394.658 -317.593 396.83 -389.628Z"
          fill="url(#paint0_linear_5743_50079)"
          shapeRendering="crispEdges"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_5743_50079"
        x="-31.4478"
        y="-589.661"
        width="658.755"
        height="865.175"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="19.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.710118 0 0 0 0 0.52549 0 0 0 0 0.945098 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5743_50079" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5743_50079"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_5743_50079"
        x1="-34.5"
        y1="109.5"
        x2="629.122"
        y2="41.1847"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A202C" />
        <stop offset="1" stopColor="#1A202C" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_5743_50079">
        <rect width="607" height="234" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const BlobTwo = () => (
  <svg
    className={cx(styles.blob, styles.blobTwo)}
    width="366"
    height="280"
    viewBox="0 0 366 280"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5940_1043)">
      <g clipPath="url(#clip1_5940_1043)">
        <g opacity="0.12" filter="url(#filter0_d_5940_1043)">
          <path
            d="M25.7132 579.089C68.1518 757.039 178.3 730.312 228.496 694.295C306.028 628.546 316.023 473.631 317.786 413.292C319.196 365.022 349.93 245.78 365.121 192.193C382.072 2.41673 240.095 13.6601 214.833 14.2249C189.571 14.7897 108.954 47.1172 29.4921 14.4038C-34.0774 -11.767 -93.4384 -10.2973 -115.173 -6.29108C-208.079 26.3782 -203.153 98.3095 -200.664 129.506C-198.174 160.702 -175.352 221.596 -81.3507 296.438C-6.1496 356.312 21.644 509.546 25.7132 579.089Z"
            fill="white"
            fillOpacity="0.5"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_5940_1043"
        x="-240.66"
        y="-43.5377"
        width="646.182"
        height="807.151"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="19.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.785647 0 0 0 0 0.52549 0 0 0 0 0.945098 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5940_1043" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5940_1043"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_5940_1043">
        <rect width="366" height="280" fill="white" />
      </clipPath>
      <clipPath id="clip1_5940_1043">
        <rect width="366" height="545" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const Star = ({ className }: { className: string }) => (
  <svg
    className={cx(styles.star, className)}
    xmlns="http://www.w3.org/2000/svg"
    width="53"
    height="53"
    viewBox="0 0 53 53"
    fill="none"
  >
    <path
      d="M26.5 0V25.9362H0L2.31922 25.2741C13.6542 22.0384 22.5175 13.3637 25.8236 2.26988L26.5 0Z"
      fill={accentColor}
      fillOpacity="0.25"
    />
    <path
      d="M26.5 53V25.9362H0L2.39109 26.6484C13.682 30.0117 22.4392 38.7809 25.6163 49.9057L26.5 53Z"
      fill={accentColor}
      fillOpacity="0.25"
    />
    <path
      d="M26.5 0V25.9362H53L50.6808 25.2741C39.3458 22.0384 30.4825 13.3637 27.1764 2.26988L26.5 0Z"
      fill={accentColor}
      fillOpacity="0.25"
    />
    <path
      d="M26.5 53V25.9362H53L50.6089 26.6484C39.318 30.0117 30.5608 38.7809 27.3837 49.9057L26.5 53Z"
      fill={accentColor}
      fillOpacity="0.25"
    />
  </svg>
);

type HomeThemeGoodVetsProps = {
  storefrontThemeConfig: { logo: Optional<string> };
};

/** Like the hero theme but customized for GoodVet. */
const HomeThemeGoodVets = ({ storefrontThemeConfig }: HomeThemeGoodVetsProps) => {
  const clinic = useClinic();
  const { logo } = storefrontThemeConfig;
  const { isTabletPortraitAndSmaller } = useBreakpoints();

  const gradient = useMemo(() => {
    const { r, g, b } = hexToRgb(primaryColor);
    const fadedPrimary = `rgba(${r}, ${g}, ${b}, 0.90)`;

    if (isTabletPortraitAndSmaller) {
      return `linear-gradient(180deg, ${primaryColor} 0%, ${primaryColor} 33%, ${fadedPrimary} 50%, transparent 80%, transparent 100%)`;
    }
    return `linear-gradient(90deg, ${primaryColor} 0%, ${primaryColor} 50%, ${fadedPrimary} 60%, transparent 80%, transparent 100%)`;
  }, [isTabletPortraitAndSmaller]);

  const heroImage = useMemo(() => {
    if (isTabletPortraitAndSmaller) {
      return goodVetThemeImageMobile;
    }
    return goodVetThemeImage;
  }, [isTabletPortraitAndSmaller]);

  return (
    <div>
      <div className={styles.theme}>
        <Header
          styles={{
            banner: styles.headerBanner,
            menuIcon: styles.menuIcon,
            nav: styles.nav,
            cartButton: styles.cartButton,
          }}
          storefrontThemeLogo={logo}
          bannerVariant="dark"
          hasWhiteIcons={false}
        />
        <div className={styles.heroImage} style={{ backgroundImage: `url(${heroImage})` }} />
        <div className={styles.gradient} style={{ background: gradient }} />
        <HomeContent.Header>
          <div>
            <div className={styles.contentHeader}>
              <HomeContent.Title className={styles.title} lineColors={accentColor} />
              <div className={styles.description}>
                Your animal&apos;s health is our top priority at {clinic.display_name}. We&apos;ve
                made it even easier to refill and request new medications through our online store.
              </div>
            </div>
          </div>
        </HomeContent.Header>
        <BlobOne />
        <BlobTwo />
        <Star className={styles.starOne} />
        <Star className={styles.starTwo} />
        <Star className={styles.starThree} />
        <Star className={styles.starFour} />
        <Star className={styles.starFive} />
        <Star className={styles.starSix} />
      </div>
      <HomeContent.Body hasLoggedinSummary={true} hasRoundedTop={false} />
    </div>
  );
};

export default HomeThemeGoodVets;
